/* eslint-disable */
// Generated by scripts/generate-aws-exports.js. Do not edit directly.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:16356a74-9887-4ae5-a14d-3c859cd713b2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_fmpfQpU5E",
    "aws_user_pools_web_client_id": "2bgjan867po886cq46qinbkr9f",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://2vkfjkkks1.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://lm7dzbtfhjd5dd7bxkkohq5jbq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "treehouseclientsphotos233841-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};

export default awsmobile;
